// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Products_container__uMIWj {
  display: flex;
  margin-left: auto; /* Centrează containerul pe orizontală */
  margin-right: auto; /* Centrează containerul pe orizontală */
  max-width: 1140px; /* Lățime maximă pentru container */
  box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */
  width: 100%;
  height: 100%;
}

.Products_sidebar__deCZ6 {
  width: 25%;
}

.Products_sidebar__deCZ6 ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.Products_sidebar__deCZ6 li {
  margin: 10px 0;
  cursor: pointer;
  color: #d9230f;
  margin-right: 35px;
}

.Products_sidebar__deCZ6 li:hover {
  color: #d9230f;
}

.Products_sidebar__deCZ6 li.Products_active__iLuOo {
  color: white;
  background-color: #d9230f;
  border-radius: 4px; /* Culoarea textului */
  padding: 0 10px;
}

.Products_containerProducts__rp1u2 {
  width: 75%;
}

.Products_grid__8TM\\+O {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Grid pe 3 coloane */
  gap: 10px;
}

.Products_productCard__Os2Vo {
  display: grid;
  grid-template-rows: 75% 15% 10%; /* Proporții fixe pentru imagine, nume și preț */
  height: 300px; /* Înălțime fixă pentru card */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
  text-align: center;
  transition: transform 0.3s, color 0.3s;
}

.Products_productCard__Os2Vo:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.Products_image__5mc\\+A {
  max-height: 100%; /* Asigură că imaginea respectă proporția */
  max-width: 100%; /* Asigură că imaginea respectă proporția */
  margin: auto; /* Centrează imaginea pe ambele axe */
  object-fit: contain; /* Păstrează proporțiile imaginii fără să o decupeze */
}

.Products_productName__uLLxV {
  font-size: 1.1em;
  margin: 0;
  color: #333;
  display: -webkit-box; /* Suport pentru trunchiere pe mai multe linii */
  -webkit-line-clamp: 2; /* Permite maximum 2 linii */
  -webkit-box-orient: vertical; /* Setează direcția conținutului */
  overflow: hidden; /* Ascunde conținutul suplimentar */
  text-align: center;
}

.Products_productPrice__QFeGF {
  font-size: 1em;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.Products_link__DiIy6 {
  text-decoration: none; /* Elimină sublinierea */
  color: inherit; /* Menține culoarea textului */
}

@media (max-width: 768px) {
  .Products_image__5mc\\+A {
    height: 350px; /* Asigură că imaginea respectă proporția */
  }

  .Products_productCard__Os2Vo {
    grid-template-rows: 90% 5% 5%; /* Proporții fixe pentru imagine, nume și preț */
  }

  .Products_productCard__Os2Vo:hover {
    transform: none;
    box-shadow: none;
  }

  .Products_container__uMIWj {
    flex-direction: column; /* Elemente aranjate pe verticală */
    padding: 0 10px; /* Reduce marginile pentru ecrane mici */
  }

  .Products_sidebar__deCZ6 {
    display: none; /* Ascunde bara laterală */
  }

  .Products_containerProducts__rp1u2 {
    width: 100%; /* Lățimea completă pentru containerul de produse */
  }

  .Products_grid__8TM\\+O {
    grid-template-columns: 1fr; /* Un produs pe rând */
    gap: 20px; /* Spațiu între carduri */
  }

  .Products_productCard__Os2Vo {
    height: auto; /* Înălțime adaptabilă */
  }

  .Products_productName__uLLxV {
    -webkit-line-clamp: 3; /* Permite până la 3 linii pe ecrane mici */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Products/Products.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB,EAAE,wCAAwC;EAC3D,kBAAkB,EAAE,wCAAwC;EAC5D,iBAAiB,EAAE,mCAAmC;EACtD,sBAAsB,EAAE,kDAAkD;EAC1E,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB,EAAE,sBAAsB;EAC1C,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,sBAAsB;EAC7D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B,EAAE,gDAAgD;EACjF,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,eAAe,EAAE,2CAA2C;EAC5D,YAAY,EAAE,qCAAqC;EACnD,mBAAmB,EAAE,sDAAsD;AAC7E;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,oBAAoB,EAAE,gDAAgD;EACtE,qBAAqB,EAAE,4BAA4B;EACnD,4BAA4B,EAAE,kCAAkC;EAChE,gBAAgB,EAAE,mCAAmC;EACrD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE;IACE,aAAa,EAAE,2CAA2C;EAC5D;;EAEA;IACE,6BAA6B,EAAE,gDAAgD;EACjF;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,mCAAmC;IAC3D,eAAe,EAAE,wCAAwC;EAC3D;;EAEA;IACE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,WAAW,EAAE,mDAAmD;EAClE;;EAEA;IACE,0BAA0B,EAAE,sBAAsB;IAClD,SAAS,EAAE,yBAAyB;EACtC;;EAEA;IACE,YAAY,EAAE,wBAAwB;EACxC;;EAEA;IACE,qBAAqB,EAAE,2CAA2C;EACpE;AACF","sourcesContent":[".container {\n  display: flex;\n  margin-left: auto; /* Centrează containerul pe orizontală */\n  margin-right: auto; /* Centrează containerul pe orizontală */\n  max-width: 1140px; /* Lățime maximă pentru container */\n  box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */\n  width: 100%;\n  height: 100%;\n}\n\n.sidebar {\n  width: 25%;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar li {\n  margin: 10px 0;\n  cursor: pointer;\n  color: #d9230f;\n  margin-right: 35px;\n}\n\n.sidebar li:hover {\n  color: #d9230f;\n}\n\n.sidebar li.active {\n  color: white;\n  background-color: #d9230f;\n  border-radius: 4px; /* Culoarea textului */\n  padding: 0 10px;\n}\n\n.containerProducts {\n  width: 75%;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Grid pe 3 coloane */\n  gap: 10px;\n}\n\n.productCard {\n  display: grid;\n  grid-template-rows: 75% 15% 10%; /* Proporții fixe pentru imagine, nume și preț */\n  height: 300px; /* Înălțime fixă pentru card */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #fff;\n  text-align: center;\n  transition: transform 0.3s, color 0.3s;\n}\n\n.productCard:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.image {\n  max-height: 100%; /* Asigură că imaginea respectă proporția */\n  max-width: 100%; /* Asigură că imaginea respectă proporția */\n  margin: auto; /* Centrează imaginea pe ambele axe */\n  object-fit: contain; /* Păstrează proporțiile imaginii fără să o decupeze */\n}\n\n.productName {\n  font-size: 1.1em;\n  margin: 0;\n  color: #333;\n  display: -webkit-box; /* Suport pentru trunchiere pe mai multe linii */\n  -webkit-line-clamp: 2; /* Permite maximum 2 linii */\n  -webkit-box-orient: vertical; /* Setează direcția conținutului */\n  overflow: hidden; /* Ascunde conținutul suplimentar */\n  text-align: center;\n}\n\n.productPrice {\n  font-size: 1em;\n  color: #888;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.link {\n  text-decoration: none; /* Elimină sublinierea */\n  color: inherit; /* Menține culoarea textului */\n}\n\n@media (max-width: 768px) {\n  .image {\n    height: 350px; /* Asigură că imaginea respectă proporția */\n  }\n\n  .productCard {\n    grid-template-rows: 90% 5% 5%; /* Proporții fixe pentru imagine, nume și preț */\n  }\n\n  .productCard:hover {\n    transform: none;\n    box-shadow: none;\n  }\n\n  .container {\n    flex-direction: column; /* Elemente aranjate pe verticală */\n    padding: 0 10px; /* Reduce marginile pentru ecrane mici */\n  }\n\n  .sidebar {\n    display: none; /* Ascunde bara laterală */\n  }\n\n  .containerProducts {\n    width: 100%; /* Lățimea completă pentru containerul de produse */\n  }\n\n  .grid {\n    grid-template-columns: 1fr; /* Un produs pe rând */\n    gap: 20px; /* Spațiu între carduri */\n  }\n\n  .productCard {\n    height: auto; /* Înălțime adaptabilă */\n  }\n\n  .productName {\n    -webkit-line-clamp: 3; /* Permite până la 3 linii pe ecrane mici */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Products_container__uMIWj`,
	"sidebar": `Products_sidebar__deCZ6`,
	"active": `Products_active__iLuOo`,
	"containerProducts": `Products_containerProducts__rp1u2`,
	"grid": `Products_grid__8TM+O`,
	"productCard": `Products_productCard__Os2Vo`,
	"image": `Products_image__5mc+A`,
	"productName": `Products_productName__uLLxV`,
	"productPrice": `Products_productPrice__QFeGF`,
	"link": `Products_link__DiIy6`
};
export default ___CSS_LOADER_EXPORT___;
